function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v48.762H0zm0 97.525h512v48.762H0zm0 97.525h512v48.762H0zM0 377.9h512v48.762H0z",
  fill: "#338af3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h256v195.05H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M192 182.857l-26.151 12.301 13.925 25.327-28.397-5.433-3.598 28.687L128 222.641l-19.78 21.098-3.597-28.687-28.397 5.432 13.925-25.326L64 182.857l26.151-12.301-13.925-25.326 28.396 5.432 3.599-28.687L128 143.074l19.78-21.099 3.597 28.687 28.398-5.432-13.926 25.327z"
});

const SvgUruguay = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUruguay, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/uruguay.7c9cda7f.svg";
export { ForwardRef as ReactComponent };